
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { accountService } from './AccountService';
import { mapGetters } from 'vuex';
import store from '@/store';

export default defineComponent({
  name: 'ConfirmEmail',
  mixins: [Form],
  data() {
    return {
      form: {
        userId: 0,
        code: '',
      },
    };
  },
  created() {
    this.send();
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    isInvalidToken() {
      return this.errorObjects && this.errorObjects.some((x) => x.code === 'InvalidToken') && this.form.userId > 0;
    },
  },
  methods: {
    async send() {
      this.form.userId = this.$route.query.userId ? (+this.$route.query.userId as number) : 0;
      this.form.code = this.$route.query.code as string;

      try {
        await accountService.confirmEmail(this.form);
        store.commit('confirmEmail');
        this.success();
      } catch (error) {
        this.handleApiError(error);
      }
    },
    async resetConfirmEmail() {
      try {
        await accountService.resetConfirmEmail(this.form.userId);
      } catch (error) {
        this.handleApiError(error);
      }
    },
  },
});
